'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaListItem = require('react-bootstrap/lib/MediaListItem');

var _MediaListItem2 = _interopRequireDefault(_MediaListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaListItem2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/MediaListItem.js
// module id = 637
// module chunks = 0